import { Component, computed } from '@angular/core';
import { EmulationService } from '../../../shared/services/emulation.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-emulation-displayer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './emulation-displayer.component.html',
  styleUrl: './emulation-displayer.component.scss',
})
export class EmulationDisplayerComponent {
  emulatedUser = computed(() => this._emulationService.emulatedUser());

  constructor(private _emulationService: EmulationService) {}

  stopEmulation() {
    this._emulationService.stopEmulation();
  }
}
